import { CategoryPromotedProductsSkeleton } from './CategoryPromotedProductsSkeleton';
import { ProductsList } from './ProductsList/ProductsList';
import Heading from 'components/Basic/Heading/Heading';
import ProductsSlider from 'components/Blocks/Product/ProductsSlider';
import { usePersoo } from 'hooks/persoo/usePersoo';
import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';
import { useMediaMin } from 'hooks/ui/useMediaMin';
import { PERSOO_IDS } from 'modules/persoo/persooTypes';
import { useMemo } from 'react';
import { SliderProductItemType } from 'types/product';

const GTM_LIST_NAME = 'top products' as const;

type CategoryPromotedProductsProps = {
    items: SliderProductItemType[];
};

export const CategoryPromotedProducts: FC<CategoryPromotedProductsProps> = ({ items }) => {
    const t = useTypedTranslationFunction();
    const { isPersooAllowed } = usePersoo();

    const isDesktop = useMediaMin('vl');

    const PromotedProducts = useMemo(() => {
        if (typeof isDesktop === 'undefined') {
            return <CategoryPromotedProductsSkeleton />;
        }

        if (isDesktop) {
            return <ProductsList products={items} gtmListName={GTM_LIST_NAME} />;
        }

        return (
            <ProductsSlider products={items} gtmListName={GTM_LIST_NAME} noMarginBottom idSuffix="-promoted-slider" />
        );
    }, [isDesktop, items]);

    if (items.length === 0) {
        return null;
    }

    return (
        <div
            className="mb-8 border-y-[5px] border-grayLight pt-5 pb-4 vl:rounded-md vl:border-[5px] vl:px-6"
            id={isPersooAllowed ? PERSOO_IDS.topProducts : undefined}
        >
            <Heading className="!text-h6 font-medium leading-6 md:mr-28 vl:mr-0 vl:text-center" type="h2">
                {t('Do not want to choose? Choose certainty')}
            </Heading>
            {PromotedProducts}
        </div>
    );
};
